import { KeyboardEvent, useState } from "react";

import { Button } from "../button";
import { DialogFooter } from "../dialog";

import BlueprintDiffViewer from "./BlueprintDiffViewer";
import CommitMessage from "./CommitMessage";

import { PromptBlueprint } from "@/types";
import LoadingSpinner from "@/components/LoadingSpinner";

interface CreateCommitMessageProps {
  data?: PromptBlueprint;
  promptName?: string;
  onClose: () => void;
  onConfirm: (commitMessage?: string) => void;
  isLoading?: boolean;
  commitLabel?: string;
  onGoBack?: () => void;
}

const CreateCommitMessage = ({
  data,
  promptName,
  onClose,
  onConfirm,
  isLoading,
  onGoBack,
  commitLabel,
}: CreateCommitMessageProps) => {
  const [commitMessage, setCommitMessage] = useState("");

  const handleKeyDown = (e: KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isLoading) {
        onConfirm(commitMessage);
      }
    }
  };

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onConfirm(commitMessage);
      }}
      onKeyDown={handleKeyDown}
      className="flex flex-col gap-y-4"
    >
      <CommitMessage message={commitMessage} setMessage={setCommitMessage} label={commitLabel} />
      {data && <BlueprintDiffViewer blueprint={data} promptName={promptName} />}
      <DialogFooter>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onGoBack ? onGoBack : onClose}>
            {onGoBack ? "Back" : "Cancel"}
          </Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? (
              <>
                <LoadingSpinner size={5} />
                Loading...
              </>
            ) : (
              "Next"
            )}
          </Button>
        </div>
      </DialogFooter>
    </form>
  );
};

export default CreateCommitMessage;
